import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Button } from 'reactstrap';
import { useIntl } from 'react-intl';
import { useHistory } from 'react-router-dom';
import { connect } from 'react-redux';

import { showModal } from '../../../actions';

import { userHasFeature } from '../../../helpers/Features';

import UpgradePlanButton from '../../UpgradePlanButton';

const AdminCustomFieldsHeader = ({ handleMetadataGroupModal, isInTrial }) => {
  const intl = useIntl();
  const history = useHistory();

  return (
    <header className={classnames('page-header with-upgrade-button', { 'mt-3': !userHasFeature('metadata-groups') || isInTrial })}>
      <h3 className="page-title">
        {intl.formatMessage({ defaultMessage: 'Custom Fields' })}
      </h3>
      <UpgradePlanButton feature="custom-fields" />
      <div className="header-actions users-actions">
        <div className="button-wrapper metadata-groups-button-wrapper">
          <Button
            color="secondary"
            onClick={handleMetadataGroupModal}
            disabled={!userHasFeature('metadata-groups')}
          >
            <i className="fas fa-plus" />
            <span>
              {intl.formatMessage({ defaultMessage: 'Metadata Group' })}
            </span>
            <UpgradePlanButton feature="metadata-groups" flying={true} simple={true} />
          </Button>
        </div>
        <div className="button-wrapper">
          <Button
            color="primary"
            onClick={() => { history.push('/admin/settings/custom-fields/add'); }}
            disabled={!userHasFeature('custom-fields')}
          >
            <i className="fas fa-plus" />
            <span>
              {intl.formatMessage({ defaultMessage: 'Custom Field' })}
            </span>
          </Button>
        </div>
      </div>
    </header>
  );
};

const mapStateToProps = state => ({
  isInTrial: state.Auth.profile.client.is_in_trial,
});

const mapDispatchToProps = dispatch => ({
  handleMetadataGroupModal: () => {
    dispatch(showModal('MetadataGroupModal', {
      className: 'modal-metadata-group',
      mode: 'add',
    }));
  },
});

AdminCustomFieldsHeader.propTypes = {
  isInTrial: PropTypes.bool.isRequired,
  handleMetadataGroupModal: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(AdminCustomFieldsHeader);
